import React from 'react';
import { useTranslation } from 'react-i18next';
import { ENV_MEDIAS_URL_ACCOUNT_CATALOG } from 'settings/env';

type Props = {
  classes?: {
    wrapper?: string;
    image?: string;
  };
};

export default function CatalogImage({ classes }: Props): JSX.Element | null {
  const { t } = useTranslation(['translation']);

  return ENV_MEDIAS_URL_ACCOUNT_CATALOG ? (
    <div className={classes?.wrapper}>
      <img
        alt={t('IMAGE_CATALOG_ALT')}
        className={classes?.image}
        src={ENV_MEDIAS_URL_ACCOUNT_CATALOG}
      />
    </div>
  ) : null;
}
